<template>
  <app-layout>
    <v-card class="ma-3 pa-3">
      <!-- Resume -->
      <v-card-title class="pt-0">
        <v-layout row wrap>
          <v-flex xs6>
            <v-layout align-center justify-start row fill-height>
              <div>
                <h2>Productos</h2>
              </div>
            </v-layout>
          </v-flex>
          <v-flex xs6>
            <!-- Action buttons -->
            <v-layout align-center justify-end row fill-height>
              <div v-if="selectedTableItems.length >= 1">
                <v-btn color="error" @click="showBulkDeleteProductModal = true">
                  <v-icon left>mdi-delete</v-icon>
                  {{ $t('Eliminar') }}
                </v-btn>
              </div>
              <div>
                <v-btn color="primary" @click="openNewProductForm()">
                  <v-icon left>mdi-plus</v-icon>
                  {{ $t('CREAR PRODUCTO') }}
                </v-btn>
              </div>
            </v-layout>
            <!-- End action buttons -->
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <open-billing-product-table
          ref="productTable"
          @on-selected-items="onSelectedItems($event)"
          @on-edit-product="onEditProduct($event)"
          @on-delete-product="onDeleteProduct($event)"
        ></open-billing-product-table>
      </v-card-text>
    </v-card>
    <open-billing-product-form
      :show-modal="showProductModalForm"
      :key="productFormKey"
      :product-id="selectedProductId"
      @click-on-close="closeProductModalForm()"
      @on-saved-product="onSavedProduct($event)"
    ></open-billing-product-form>
    <!-- Modal to delete single products -->
    <v-layout row justify-center>
      <v-dialog v-model="showDeleteProductModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Eliminar') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>
                    ¿Estás seguro de eliminar el producto seleccionado?
                  </h2>
                  <small>Esta acción no es reversible</small>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="closeDeleteProductModal()">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="confirmDeleteProduct()">
              {{ $t('Eliminar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->
    <!-- Modal to delete bulk contacts -->
    <v-layout row justify-center>
      <v-dialog v-model="showBulkDeleteProductModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Eliminar') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>
                    ¿Estás seguro de eliminar los productos seleccionados?
                  </h2>
                  <small>Esta acción no es reversible</small>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="showBulkDeleteProductModal = false">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="confirmDeleteBulkProducts()">
              {{ $t('Eliminar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout';
import OpenBillingProductTable from '@/modules/openbilling/components/OpenBillingProductTable';
import OpenBillingProductForm from '@/modules/openbilling/components/OpenBillingProductForm';
import apiCtrl from '@/services/api/abstract/abstract-api';

export default {
  name: 'OpenBillingContacts',
  components: {
    AppLayout,
    'open-billing-product-table': OpenBillingProductTable,
    'open-billing-product-form': OpenBillingProductForm,
  },
  props: [],
  data() {
    return {
      showProductModalForm: false,
      showDeleteProductModal: false,
      showBulkDeleteProductModal: false,
      productFormKey: 0,
      selectedProductId: null,
      selectedTableItems: [],
    };
  },
  mounted() {},
  computed: {
    clavedat() {
      return this.$store.state.clavedat;
    },
  },
  methods: {
    openNewProductForm() {
      this.showProductModalForm = true;
    },
    closeProductModalForm() {
      this.showProductModalForm = false;
      this.resetProductForm();
    },
    resetProductForm() {
      this.productFormKey++;
      this.selectedProductId = null;
    },
    onSavedProduct() {
      this.closeProductModalForm();
      this.getProducts();
    },
    onEditProduct(product) {
      this.selectedProductId = product.id;
      this.showProductModalForm = true;
    },
    onDeleteProduct(product) {
      this.selectedProductId = product.id;
      this.showDeleteProductModal = true;
    },
    onSelectedItems(selectedItems) {
      this.selectedTableItems = selectedItems;
    },
    confirmDeleteProduct() {
      this.deleteSingleContact(this.selectedProductId);
    },
    confirmDeleteBulkProducts() {
      let ids = [];
      this.selectedTableItems.forEach(item => {
        ids = ids.concat(item['id']);
      });
      this.deleteBulkProducts(ids);
    },
    closeDeleteProductModal() {
      this.showDeleteProductModal = false;
      this.selectedProductId = null;
    },
    deleteSingleContact(id) {
      apiCtrl
        .post(`/openbilling/${this.clavedat}/products/delete`, { id: id })
        .then(() => {
          this.closeDeleteProductModal();
          this.getProducts();
        })
        .catch(err => {
          console.log(err);
          this.closeDeleteProductModal();
        });
    },
    deleteBulkProducts(ids) {
      apiCtrl
        .post(`/openbilling/${this.clavedat}/products/bulk-delete`, { ids: ids })
        .then(() => {
          this.showBulkDeleteProductModal = false;
          this.getProducts();
        })
        .catch(err => {
          console.log(err);
          this.showBulkDeleteProductModal = false;
        });
    },
    getProducts() {
      this.$refs.productTable.getBillingProducts();
    },
  },
  watch: {},
};
</script>

<style scoped></style>
